interface JsonCSRFToken {
  value: string;
}

import {AjaxP} from '@mamdev/cad.static-next-lib';

export const AjaxPost = {
  ajaxp_: AjaxP,
  csrfUrl_: window.location.protocol + '//' + window.location.host + '/magazine/ajax/csrf',
  csrfToken_: '',

  setCSRFHost(host: string) {
    this.csrfUrl_ = host + '/magazine/ajax/csrf';
  },

  getCSRFToken(): string {
    // CADNPCA-6929
    const tokenData = window.ui.csrfToken;

    if (typeof tokenData !== 'undefined' && tokenData) {
      if (typeof tokenData.local !== 'undefined' && tokenData.local) {
        return tokenData.value;
      }

      const tokenExp = new Date(tokenData.expires);
      const now = new Date();
      if (tokenExp >= now) {
        return tokenData.value;
      }
    }

    return '';
  },

  async postJSON<T>(url: string, data: T, additionalHeaders = {}): Promise<unknown> {
    this.csrfToken_ = this.getCSRFToken();
    if (this.csrfToken_) {
      return AjaxP.postJSON(url, data, Object.assign(additionalHeaders, {'X-CSRF-TOKEN': this.csrfToken_}));
    } else {
      return AjaxP.getJSON<JsonCSRFToken>(this.csrfUrl_).then((jsonData: JsonCSRFToken) => {
        this.csrfToken_ = jsonData.value;
        return AjaxP.postJSON(url, data, Object.assign(additionalHeaders, {'X-CSRF-TOKEN': this.csrfToken_}));
      });
    }
  }
};
